<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardBody>
            <CButton color="success" @click="createProduct()" class="mb-4"><CIcon name="cil-plus" height="48"/> Add Size</CButton>
            <CAlert
              :show.sync="dismissCountDown"
              color="primary"
              fade
            >
              ({{dismissCountDown}}) {{ message }}
            </CAlert>
            <CDataTable
              hover
              :items="items"
              :fields="fields"
              :items-per-page="100"
              pagination
              columnFilter
              tableFilter
              sorter
            >
              <template #logo="{item}">
                <td>
                  <img :src="item.logo" style="height: 50px;width: 90px;"/>
                </td>
              </template>
              <template #marque="{item}">
                <td>
                  <span>{{item.name}}</span>
                </td>
              </template>
              <template #code="{item}">
                <td>
                  <strong>{{item.code}}</strong>
                </td>
              </template>

              <template #sizes="{item}">
                <td>
                  <span 
                    class="badge badge-info" 
                    v-for="size in item.sizes"
                    :key="'size1'+size.id"
                    v-show="item.sizes.length>0"
                  >
                    {{size.name}}
                  </span>
                  <span v-if="!item.sizes.length">
                    il n'y a pas de tailles spécifiées pour ce type!
                  </span>
                  <button class="button-custom" @click="manageModal(item)">Gérer les tailles</button>
                </td>
              </template>
              
              <template #add="{item}">
                <td>
                  <span>{{item.created_at}}</span>
                </td>
              </template>
              <template #modify="{item}">
                <td>
                  <span>{{item.updated_at}}</span>
                </td>
              </template>
              
              <template #Options="{item}">
                <td class="text-right">
                  <!-- <CButton color="primary" @click="showNote( item.id )" class="mr-2"><CIcon name="cil-center-focus" height="48"/> </CButton> -->
                  <CButton color="warning" @click="$router.push('types/'+item.id+'/update')" class="option-btn"><CIcon name="cil-pencil" height="48"/> </CButton>
                  <CButton v-if="you!=item.id" color="danger" @click="deleteToast( item )" class="option-btn"><CIcon name="cil-trash" height="48"/> </CButton>
                </td>
              </template>
            </CDataTable>
        </CCardBody>  
        <modal 
          :width="'300px'" 
          :maxWidth="200"
          :height="'auto'" 
          :name="'modal'"
          :styles="{
            zIndex: 99999
          }"
        >
          <div class="modal-div" style="padding: 20px 50px;max-height: 500px !important;overflow-x: hidden;">
            <div class="title">
              Tailles du <b>{{selected_type.name}}</b>
            </div>
            <div class="" v-if="selected_type.sizes && !selected_type.sizes.length">
              il n'y a pas de tailles spécifiées pour ce type!
            </div>
            <div class="row modal-size" v-else v-for="size in selected_type.sizes" :key="'size2'+size.id">
              <div class="col-6" style="float: left;margin-top: 5px;font-weight: bold;">
                {{size.name}}
              </div>
              <div class="col-6" style="text-align: right">
                <CButton color="danger" class="option-btn" @click="deleteSize(size.id)"><CIcon name="cil-trash" height="48"/> </CButton>
              </div>
            </div>
            <br>
            Ajouter un nouveau taille 
            <div class="row modal-size">
              <div class="col-6" style="float: left;margin-top: 5px;font-weight: bold;">
                <input type="text" placeholder="Taille" v-model="toAdd.size" style="height: 28px;">
              </div>
              <div class="col-6" style="text-align: right">
                <CButton color="success" class="option-btn" @click="addSize(selected_type.id)"><CIcon name="cil-plus" height="48"/> </CButton>
              </div>
            </div>
          </div>
        </modal>
      </CCard>
      </transition>
    </CCol>
    <vue-confirm-dialog></vue-confirm-dialog>
  </CRow>
</template>

<script>
import axios from 'axios'
import {sizeService} from '../../../_services';
import moment from 'moment'

export default {
  name: 'Notes',
  data: () => {
    return {
      selected_type: [],
      toAdd:{
        size: ''
      },
      items: [],
      fields: [
        {key: 'logo', label: '#', sorter: false, filter: false},
        {key: 'name', label: 'Nom'},
        {key: 'code', label: 'Code'},
        {key: 'sizes', label: 'Tailles'},
        {key: 'add', label: 'Date d\'ajout'},
        {key: 'modify', label: 'Dérniere modification'},
        {key: 'Options', label: 'Options', sorter: false, filter: false},
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  computed: {
  },
  methods: {
    deleteSize(id){
        this.loader = this.$loading.show();

        sizeService.delete(id).then(function (data) {
          this.$toast.success('taille supprimée avec succès');
          this.message = "added successfully";
          this.selected_type.sizes= data.data.data
          this.toAdd.size= ''
        }.bind(this)).finally(function () {
          this.loader.hide();
        }.bind(this))
    },
    addSize(id){
      if(this.toAdd.size!=''){
        this.loader = this.$loading.show();
        let data={
          product_type_id: id,
          name: this.toAdd.size
        }
        sizeService.create(data).then(function (data) {
          this.$toast.success('taille créé avec succès');
          this.message = "added successfully";
          this.selected_type.sizes= data.data.data
          this.toAdd.size= ''
        }.bind(this)).finally(function () {
          this.loader.hide();
        }.bind(this))
      }
    },
    manageModal(data){
      this.selected_type= data;
      this.$modal.show('modal')
    },
    getRowCount (items) {
      return items.length
    },
    noteLink (id) {
      return `notes/${id.toString()}`
    },
    editLink (id) {
      return `product/${id.toString()}/edit`
    },
    showNote ( id ) {
      const noteLink = this.noteLink( id );
      this.$router.push({path: noteLink});
    },
    editNote ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    deleteNote ( id ) {
      this.loader = this.$loading.show();
    
      typeService.delete(id).then(function(data){
        this.items = data.data.data.map((obj)=>{
            obj.created_at= moment(obj.created_at).format('DD MMMM YYYY')
            obj.updated_at= moment(obj.updated_at).format('DD MMMM YYYY')
            return obj
        });
      }.bind(this)).finally(
          function () {
            this.loader.hide();
          }.bind(this)
      );
    },
    createProduct () {
      this.$router.push({path: 'types/create'});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    getProducts (){
      let self = this;
      this.loader = this.$loading.show();
      typeService.getAll().then(function (response) {
        self.items = response.data.map((obj)=>{
            obj.created_at= moment(obj.created_at).format('DD MMMM YYYY')
            obj.updated_at= moment(obj.updated_at).format('DD MMMM YYYY')
            return obj
        });
      }).finally(function () {
        this.loader.hide();
      }.bind(this));
    },
    deleteToast(item){
      this.$confirm(
        {
          title: `Confirmation!`,
          message: 'êtes-vous sûr de supprimer la marque \''+item.name+'\'?',
          button: {
            no: 'Annuler',
            yes: 'Supprimer'
          },
          /**
          * Callback Function
          * @param {Boolean} confirm 
          */
          callback: confirm => {
            if (confirm) {
              this.deleteNote(item.id)
            }
          }
        }
      )
    }
  },
  mounted: function(){
    this.getProducts();
  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.badge{
  margin-right: 5px;
  margin-bottom: 5px;
  font-size: 10px;
}
.option-btn{
  margin-bottom: 5px;
  margin-right: 5px;
}

.modal-size{
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 5px;
  padding-top: 5px;
}
.button-custom{
  display: block;
  width: 100%;
  height: 25px;
  margin-top: 10px;
  border: none;
  background-color: #f9b115;
  color: #fff;
  border-radius: 5px;
}
.button-custom:hover{
  opacity: .8;
}
.modal-size input{
  border: 1px solid #888;height: 20px;padding-left: 10px;border-radius: 5px;
}
.modal-div .title{
  text-align: center;
  font-size: 16px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}
</style>
